import React from 'react';
import Spinner from '../../../../components/LazyWidgets/Spinner';
import style from './Loader.module.css';

const Loader = () => (
  <div className={style.loadingWrapper}>
    <div className={style.loadingContainer}>
      <Spinner className={style.mlLoading} />
    </div>
  </div>
);

export default Loader;
